import styled, { css } from 'styled-components'
import Text from '@web-ui-kit/text'
import { LAYOUT_GRID } from 'utils/constants/layout'

import { getColor, getFontFamily, getSpace } from 'utils/rebrandingUtils'

export const ModalActivityContainer = styled.div`
  text-align: center;

  ${({ isFullscreen }) =>
    !isFullscreen &&
    css`
      max-width: 445px;
    `}
`

export const ModalInfoContainer = styled.div`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  height: 100vh;
  justify-content: center;
  padding: 0 2.813rem;
  position: absolute;
  text-align: center;
  width: 100%;
  z-index: 101;
`

export const CommentsList = styled.div`
  height: 100%;
  overflow-y: scroll;
  padding-bottom: ${({ theme }) => getSpace(theme, 'M')};
`

export const ModalCommentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const ModalContainer = styled.div`
  height: auto;
  width: 537px;
  position: relative;

  ${({ isMobile }) =>
    isMobile &&
    css`
      & > div {
        padding: ${({ theme }) => `${getSpace(theme, 'BASE')} ${getSpace(theme, 'S')}`};
        gap: ${({ theme }) => getSpace(theme, 'BASE')};
      }
    `}
`

export const ModalCredentialsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  justify-content: center;
  width: 24.5rem;
  @media only screen and (max-width: ${LAYOUT_GRID.MOBILE.max}) {
    width: fit-content;
  }
`

export const ModalCredentialsBody = styled(Text)`
  margin-bottom: ${({ theme }) => getSpace(theme, 'M')};
`

export const ModalCredentialsContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`

export const ModalBody = styled.div`
  color: ${({ theme }) => getColor(theme, 'NEUTRAL_800')};
`

export const RadioButtonContainer = styled.div`
  margin-top: ${({ theme }) => getSpace(theme, 'S')};
`

export const BottomActionsContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => getSpace(theme, 'XS')};
  justify-content: center;

  button {
    min-width: 9.375rem;
    width: auto;
  }
`

export const ModalLinkFormTitle = styled.div`
  color: ${({ theme }) => getColor(theme, 'NEUTRAL_900')};
  font-family: ${({ theme }) => getFontFamily(theme, 'headline')};
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.375rem;
  text-align: center;
`

export const ModalContentTitle = styled(Text)`
  text-align: center;
  margin: 0;
`
